export default __webpack_public_path__ + "static/media/36I-102765_-17095_0.9dc44c4a.jpg";